import { BrandLogo } from './brand/BrandLogo.tsx';
import { ErrorState } from './ui/States.tsx';
import { Spinner } from './ui/Button.tsx';
import './SplashScreen.css';

export function SplashScreen({ label = 'กำลังโหลด…' }: { label?: string }) {
  return (
    <div className="splash" aria-busy="true">
      <BrandLogo size={64} />
      <div className="splash__status">
        <Spinner size={18} label={label} />
        <span aria-hidden="true">{label}</span>
      </div>
    </div>
  );
}

export function FullPageError({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  return (
    <div className="splash">
      <BrandLogo size={56} />
      <ErrorState title="เปิดระบบไม่สำเร็จ" error={error} onRetry={onRetry} />
    </div>
  );
}
